import { render, staticRenderFns } from "./bookrepair.vue?vue&type=template&id=7faa0621&scoped=true"
import script from "./bookrepair.js?vue&type=script&lang=js&external"
export * from "./bookrepair.js?vue&type=script&lang=js&external"
import style0 from "./bookrepair.vue?vue&type=style&index=0&id=7faa0621&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7faa0621",
  null
  
)

export default component.exports